import React from 'react';
import Header from '../global/Header';
import { Typography, Box, Grid } from '@mui/material';
import useAuth from '../../../hooks/useAuth';
import { motion } from 'framer-motion';
import ADCTrafficChart from '../global/Widgets/ADCTrafficChart';
import ManageResourcesWidget from '../global/Widgets/ManageResourcesWidget';
import RealTimeServices from '../global/Widgets/RealTimeServices';
import ADCCookiePool from '../global/Widgets/ADCCookiePool';

const Dashboard = () => {
  const { role } = useAuth();

  const fadeInVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <Box m="20px">
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={4}>
        <Header title="DASHBOARD" subtitle="Welcome to the Five By Five Dashboard. Click the title of any widget for more." />
      </Box>
      {role === 'Admin' && (
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6} md={4}>
            <motion.div
              initial="hidden"
              animate="visible"
              variants={fadeInVariants}
              transition={{ duration: 0.5 }}
            >
              <ADCTrafficChart />
            </motion.div>
            <Box mt={2}>
              <motion.div
                initial="hidden"
                animate="visible"
                variants={fadeInVariants}
                transition={{ duration: 0.5, delay: 0.1 }}
              >
                <ADCCookiePool />
              </motion.div>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <motion.div
              initial="hidden"
              animate="visible"
              variants={fadeInVariants}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <RealTimeServices />
            </motion.div>
            <Box mt={2}>
              <motion.div
                initial="hidden"
                animate="visible"
                variants={fadeInVariants}
                transition={{ duration: 0.5, delay: 0.3 }}
              >
                {/*<ManageResourcesWidget />*/}
              </motion.div>
            </Box>
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default Dashboard;
